/** @jsxImportSource @emotion/react */

import React, { FC, useEffect } from 'react'
import { Link } from 'react-router-dom'
import Button from '@mui/material/Button'
import IconButton from '@mui/material/IconButton'
import { PlatformName } from '__generatedTypes__/globalTypes'
import { cmsRoutes, useLink } from 'routes/cmsRoutes'
import Table, { FooterWrapper, HeaderWrapper, PaginationPage, PaginationTake } from 'components/Table'
import Badge from 'components/Badge'
import { Search } from 'components/Input'
import { ReactComponent as EditIcon } from 'assets/icons/edit.svg'
import { getLevelOption } from '../Form/consts'
import { useQuestionPassages } from './useQuestionPassages'
import * as classes from './styles'

export const QuestionPassageList: FC = () => {
  const { getLink } = useLink()
  const { items, refetch, pagination, search, order, loaded } = useQuestionPassages()

  useEffect(() => {
    refetch()
  }, [refetch])

  return (
    <div css={classes.container}>
      <Link to={getLink(cmsRoutes.CARS_QUESTION_CREATE)} css={classes.createButton}>
        <Button size="medium" color="blue">
          New CARS Question
        </Button>
      </Link>
      <HeaderWrapper css={classes.headerWrapper}>
        <Search {...search} css={classes.search} />
        <PaginationPage {...pagination} />
      </HeaderWrapper>
      <Table
        columns={[
          {
            title: 'Title',
            renderCell: (questionPassage) => questionPassage.title,
            flex: 2,
          },
          {
            title: 'Platform',
            renderCell: () => <Badge text={PlatformName.CARSBooster} css={classes.badge} color="#2489FF" />,
            flex: 1,
          },
          {
            title: 'Game Category',
            renderCell: (questionPassage) => questionPassage.subject.tabName,
            flex: 1,
          },
          {
            title: 'Level',
            renderCell: (questionPassage) =>
              questionPassage.level.map((level) => getLevelOption(level)?.title).join(', '),
            flex: 1,
          },
          {
            title: 'Date Created',
            renderCell: (questionPassage) => new Date(questionPassage.createdAt).toLocaleDateString(),
            flex: '0 1 124px',
            orderField: 'createdAt',
          },
          {
            renderCell: (questionPassage) => (
              <Link
                to={getLink(cmsRoutes.CARS_QUESTION_EDIT, {
                  questionPassageId: questionPassage.id,
                })}
              >
                <IconButton size="small" css={classes.link}>
                  <EditIcon />
                </IconButton>
              </Link>
            ),
            flex: '0 1 30px',
          },
        ]}
        items={items}
        order={order.value}
        onOrder={order.onChange}
        wrapperMinWidth={980}
        isNotLoaded={!loaded}
      />
      <FooterWrapper>
        <PaginationTake {...pagination} />
      </FooterWrapper>
    </div>
  )
}
